import axios from 'axios';

const API_BASE = window.API_URL || process.env.REACT_APP_API_URL || 'https://api.vestgrow.dpdns.org/api';
const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use(config => {
  const token = localStorage.getItem('admin_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('admin_token');
      localStorage.removeItem('admin_info');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export const adminAPI = {
  login: (data) => api.post('/auth/admin/login', data),
  dashboard: () => api.get('/admin/dashboard'),
  users: (params) => api.get('/admin/users', { params }),
  user: (id) => api.get(`/admin/users/${id}`),
  updateUser: (id, data) => api.patch(`/admin/users/${id}`, data),
  setUserPassword: (id, data) => api.post(`/admin/users/${id}/set-password`, data),
  transactions: (params) => api.get('/admin/transactions', { params }),
  processTransaction: (id, data) => api.post(`/admin/transactions/${id}/process`, data),
  products: () => api.get('/admin/products'),
  createProduct: (data) => api.post('/admin/products', data),
  updateProduct: (id, data) => api.patch(`/admin/products/${id}`, data),
  deleteProduct: (id) => api.delete(`/admin/products/${id}`),
  // inside the adminAPI object:
loanPlans:      ()         => api.get('/admin/loan-plans'),
createLoanPlan: (data)     => api.post('/admin/loan-plans', data),
updateLoanPlan: (id, data) => api.patch(`/admin/loan-plans/${id}`, data),
deleteLoanPlan: (id)       => api.delete(`/admin/loan-plans/${id}`),
loans:          (params)   => api.get('/admin/loans', { params }),
processLoan:    (id, data) => api.post(`/admin/loans/${id}/process`, data),
 // VestTrades Tier Management
  vestTiers:        ()         => api.get('/admin/vest-tiers'),
  createVestTier:   (data)     => api.post('/admin/vest-tiers', data),
  updateVestTier:   (id, data) => api.patch(`/admin/vest-tiers/${id}`, data),
  deleteVestTier:   (id)       => api.delete(`/admin/vest-tiers/${id}`),

  // VestTrades Investments Overview
  vestInvestments:  (params)   => api.get('/admin/vest-investments', { params }),

  // News
  newsList:   ()     => api.get('/admin/news'),
  createNews: (data) => api.post('/admin/news', data),
  deleteNews: (id)   => api.delete(`/admin/news/${id}`),

  settings: () => api.get('/admin/settings'),
  saveSettings: (updates) => api.post('/admin/settings', { updates }),

  // Transfer settings (convenience wrappers — backed by the same generic settings endpoint)
  getTransferSettings: () => api.get('/admin/settings'),
  saveTransferSettings: (minTransfer, feeRate) => api.post('/admin/settings', {
    updates: [
      { key: 'min_transfer',      value: String(minTransfer) },
      { key: 'transfer_fee_rate', value: String(feeRate) },
    ],
  }),
  banners: () => api.get('/admin/banners'),
  addBanner: (data) => api.post('/admin/banners', data),
  deleteBanner: (id) => api.delete(`/admin/banners/${id}`),
  notify: (data) => api.post('/admin/notify', data),

  // Promo Codes
  promoCodes:         ()         => api.get('/admin/promo-codes'),
  createPromoCode:    (data)     => api.post('/admin/promo-codes', data),
  updatePromoCode:    (id, data) => api.patch(`/admin/promo-codes/${id}`, data),
  deletePromoCode:    (id)       => api.delete(`/admin/promo-codes/${id}`),
  getPromoCodeUsages: (id)       => api.get(`/admin/promo-codes/${id}/usages`),
};

export default api;